module.exports = __webpack_public_path__ + "static/media/vtmv.54caf905.jpg";